module.exports = __webpack_public_path__ + "img/dataservice_sfjdy.76b721df.png";